import apiClient from './client';
import type { OperationsFleetResponse } from '@/types/operations';

interface OperationsFleetRequest {
  organization_id?: number;
}

export async function getOperationsFleet(
  params: OperationsFleetRequest = {},
): Promise<OperationsFleetResponse> {
  const response = await apiClient.get<OperationsFleetResponse>(
    '/api/v1/surveillance/operations-fleet',
    { params },
  );
  return response.data;
}
